import { showError, hideFlash } from 'utils/messages';
import { setLocation } from 'utils/wrappers';

import Base from 'app/views/base';
import tmpl from 'templates/request_report';

export default Base.extend({
  compiledTemplate: tmpl,
  maxReportTimeSpanDays: 31,

  events: {
    'click #request-report': 'requestReport',
  },

  initialize({ ReportClass, apiMode, dateRange, dropdownSelections = [] }) {
    this.ReportClass = ReportClass;
    this.apiMode = apiMode;
    this.dateRange = dateRange;
    this.dropdownSelections = dropdownSelections ;
    this.listenTo(this.collection, 'sync', hideFlash);
  },

  requestReport() {
    if (!this.datesOkForReport()) {
      showError(`Sorry, CSV reports are limited to ${this.maxReportTimeSpanDays} days at a time.`);
      return;
    }
    // if (!this.collection.length) {
    if (this.collection && !this.collection.length) {
      showError('Sorry, your requested search included no reports to generate a CSV with.');
      return;
    }

    new this.ReportClass().save(this.paramsForReport(), {
      success(model) {
        const reportId = model.get('id');
        const mode = model.get('mode');
        setLocation(`/account/reports/${model.reportType}#/${reportId}?mode=${mode}`);
      },
      error(model, resp) {
        const msg = resp.responseJSON.error.message;
        showError(`Error: ${msg}. If this continues, please let us know at support@easypost.com.`);
      },
    });
  },

  datesOkForReport() {
    const maxTimeSpanMillis = this.maxReportTimeSpanDays * 24 * 60 * 60 * 1000;
    const timeSpanMillis = (
      this.dateRange.getDayAfterEndDatetimeForParam() - this.dateRange.getStartDatetimeForParam()
    );
    return timeSpanMillis <= maxTimeSpanMillis;
  },

  paramsForReport() {
    return {
      send_email: true,
      mode: this.apiMode.escape('mode'),
      start_date: this.dateRange.getStartDatetimeForParam().format('YYYY-MM-DD'),
      end_date: this.dateRange.getDayAfterEndDatetimeForParam().format('YYYY-MM-DD'),
      ...this.dropdownSelections.reduce((obj, dropdownSelection) => ({
        ...obj,
        ...dropdownSelection.getParams(),
      }), {})
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/request_report_view.js